import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService, CmsService, ProtectedRoutesService, SemanticPathService } from '@spartacus/core';
import { AuthService as SSOAuth } from '@auth0/auth0-angular';
import { from } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { LogoutGuard } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root',
})
export class GenLogoutGuard extends LogoutGuard implements CanActivate {
  constructor(
    override auth: AuthService,
    override cms: CmsService,
    override semanticPathService: SemanticPathService,
    override protectedRoutes: ProtectedRoutesService,
    override router: Router,
    private ssoAuth: SSOAuth
  ) { 
    super(auth, cms, semanticPathService, protectedRoutes, router)
  }

  override logout(): Promise<any> {
    return from(this.auth.coreLogout())
      .pipe(
        switchMap(() =>
          from(this.ssoAuth.logout({ logoutParams: { returnTo: window.location.origin + '/login' } }))
        ),
        debounceTime(300)
      )
      .toPromise();
  }
}
